export default "__VITE_ASSET__BZdUBVWF__"